var map = {
	"./help-centre/app.config.js": 5686,
	"./login/app.config.js": 7778,
	"./myaccount/app.config.js": 6626,
	"./players/app.config.js": 2694,
	"./search/app.config.js": 8467,
	"./store/app.config.js": 846
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5595;